import React, { Component } from 'react';
import { connect } from 'react-redux';
import { userLogin } from 'react-admin';
import { MuiThemeProvider } from '@material-ui/core/styles';

class AppLogin extends Component {
	submit = (e) => {
		e.preventDefault();
		// gather your data/credentials here
		const credentials = {};

		// Dispatch the userLogin action (injected by connect)
		this.props.userLogin(credentials);
	}

	render() {
		var authorised = false;
		var search = this.props.location.search;
		var tokenPos = search.indexOf("token=");
		var emailPos = search.indexOf("email=");
		var idPos = search.indexOf("id=");
		if (tokenPos !== -1) {
			var token = search.substring(tokenPos + 6);
			var email = search.substring(emailPos + 6, idPos - 1);
			var id = search.substring(idPos + 3, tokenPos - 1);
			authorised = true;
		}
		
		if (authorised) {
			this.props.userLogin({
				id: id,
				username: email,
				password: token
			});
			return (
				<MuiThemeProvider theme={this.props.theme}>
					<form onSubmit={this.submit}>
						<h3>Authorised, redirecting...</h3>
					</form>
				</MuiThemeProvider>
			);
		}
		else {
			return (
				<MuiThemeProvider theme={this.props.theme}>
					<form onSubmit={this.submit}>
						<h3>Unauthorised</h3>
					</form>
				</MuiThemeProvider>
			);
		}
	}
}

export default connect(undefined, { userLogin })(AppLogin);


// WEBPACK FOOTER //
// ./src/pages/AppLogin.js